// Actions
export const SCREEN_SIZE__UPDATE_SCREEN = 'SCREEN_SIZE__UPDATE_SCREEN';
// Mutations
export const SCREEN_SIZE__MUTATE_SCREEN = 'SCREEN_SIZE__MUTATE_SCREEN';
